"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
// import { OsmosysTooltip } from './OsmosysTooltip';
exports.UserTextList = ({ users, noUsersMessage }) => {
    return users && users.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        "Assigned to",
        ' ',
        users.map((u, i) => {
            let text = (u.fullName || u.email || `User #${u.id}`).trim();
            if (users.length > 1 && users.length - 1 !== i) {
                text =
                    users.length > 2 && i === users.length - 2
                        ? `${text} and `
                        : `${text}, `;
            }
            return text;
            // return (
            //   <OsmosysTooltip key={u.id} span label={u.email}>
            //     {text}
            //   </OsmosysTooltip>
            // );
        }))) : (react_1.default.createElement(react_1.default.Fragment, null, noUsersMessage || 'No users'));
};
//# sourceMappingURL=UserTextList.js.map